;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('artsSearchFilter', artsSearchFilter)

  /* @ngInject */
  function artsSearchFilter () {
    return {
      restrict: 'E',
      scope: {
        setFilters: '='
      },
      replace: true,
      templateUrl: '/arts/directives/arts-search-filter/arts-search-filter-directive.html?$$REVISION$$',
      controller: 'ArtsSearchFilterController'
    }
  }
})()
